import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { TeamsConnectionFormState } from "./teams-connection-config";

export function TeamsConnectionFields({
  value,
  onChange,
}: {
  value: TeamsConnectionFormState;
  onChange: (value: TeamsConnectionFormState) => void;
}) {
  const update = <K extends keyof TeamsConnectionFormState>(
    key: K,
    nextValue: TeamsConnectionFormState[K],
  ) => {
    onChange({ ...value, [key]: nextValue });
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Azure Bot Registration */}
      <Card>
        <CardHeader>
          <CardTitle>Azure Bot Registration</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <FormField label="App ID">
            <input
              value={value.appId}
              onChange={(e) => update("appId", e.target.value)}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              className="form-input font-mono"
            />
            <FieldHint text="From Azure Bot registration." />
          </FormField>

          <FormField label="App Password">
            <input
              type="password"
              value={value.appPassword}
              onChange={(e) => update("appPassword", e.target.value)}
              className="form-input font-mono"
            />
            <FieldHint text="Client secret from Azure Bot registration." />
          </FormField>

          <FormField label="Tenant ID">
            <input
              value={value.tenantId}
              onChange={(e) => update("tenantId", e.target.value)}
              placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
              className="form-input font-mono"
            />
            <FieldHint text="Azure AD tenant ID. Leave empty for multi-tenant bots." />
          </FormField>
        </CardContent>
      </Card>

      {/* Webhook */}
      <Card>
        <CardHeader>
          <CardTitle>Webhook</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormField label="Port">
              <input
                value={value.webhookPort}
                onChange={(e) => update("webhookPort", e.target.value)}
                placeholder="3978"
                className="form-input font-mono"
              />
              <FieldHint text="Bot Framework webhook port." />
            </FormField>

            <FormField label="Path">
              <input
                value={value.webhookPath}
                onChange={(e) => update("webhookPath", e.target.value)}
                placeholder="/api/messages"
                className="form-input font-mono"
              />
              <FieldHint text="Bot Framework messages endpoint." />
            </FormField>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

function FormField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-medium" style={{ color: "var(--text-strong)" }}>
        {label}
      </label>
      {children}
    </div>
  );
}

function FieldHint({ text }: { text: string }) {
  return (
    <p className="text-[11px]" style={{ color: "var(--muted-foreground)" }}>
      {text}
    </p>
  );
}
